// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 761) return "static/chunks/d0deef33-ba8e3b68fa4ac34f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"669":"16ed04d04d473abd","759":"2cd323e0142c156a"}[chunkId] + ".js";
};